import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { getPath } from 'checkout/store/selectors/router';
import { goToPathAction } from 'checkout/store/actions/view';
import {
  getCompletedStep,
  getOrderIsFinished,
} from 'checkout/store/selectors/order';
import { getIsManualPackage } from 'checkout/store/selectors/package';

import SidebarMenu from './SidebarMenu';

const mapStateToProps = (state) => ({
  current: getPath(state),
  completedStep: getCompletedStep(state),
  isManualPackage: getIsManualPackage(state),
  isOrderFinished: getOrderIsFinished(state),
});

const mapDispatchToProps = (dispatch) => ({
  goToPath: (to) => dispatch(goToPathAction(to)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SidebarMenu);
